import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

class Hosting extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }



    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {



        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 150px 0 30px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 30px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 50px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            margin-bottom: 0px;
        `

        const ServiceHeadinga = styled.a`
            font-family: Oswald;
            color: #78c91c;
            transition: .5s;
            &:hover {
              color: #1a1a1a;
              text-decoration: none;
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #84a841;
            margin-bottom: 5px;
        `

        const ServiceLinea = styled.div`
            height: 1px;
            width: 200px;
            background-color: #808080;
            margin: 2px 0 7px 0;
         `

        const ServiceNumber = styled.p`            
            font-size: 30px;
            color: #717171;
            font-weight: 900;
            top: -50px;
            opacity: .1;
            z-index: -1;
            transition: .2s;
         `

        const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .3 !important;
                color: #65ff00;
            }
        `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #555555;
            padding-right: 25px;            
        `

        const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #78c91c;
            padding-right: 25px;            
        `

        const Submit = styled.a`
            background-color: #fff !important;
            color: #4b7d2f !important;
            border: solid 1px #4b7d2f;
            cursor: pointer !important;
            border-radius: 3px;
            font-size: 14px;
            line-height: 1;
            margin: 0;
            padding: 17px 26px;
            position: relative;
            letter-spacing: 0.02em;
            font-family: "Open Sans Semibold";
            box-shadow: 0 2px 8px 0 rgba(62, 62, 79, .23);
	        -webkit-transition: all 300ms linear 0ms;
	        -moz-transition: all 300ms linear 0ms;
	        -ms-transition: all 300ms linear 0ms;
            transition: all 300ms linear 0ms;
            display: inline-block;
            font-weight: 400;            
            text-transform: uppercase;          
            &:hover {              
                transform: translateX(-20%);
                text-decoration: none;
                background-color: #c1eb18 !important;
	            color: #000 !important;
	            border: none;
                box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .30);
	            -webkit-transform: translateY(-5px);
	            transform: translateY(-5px);              
            }            
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #6c6c6c;            
        `
        const Color1 = styled.span`            
            font-weight: bold;
            color: #ff0000;            
        `

        const Color2 = styled.span`            
            font-weight: bold;
            color: #40a832;            
        `
        const ColorAdmin = styled.span`            
            font-weight: bold;
            color: #31B7E9;            
        `
        const ColorCpanel = styled.span`            
            font-weight: bold;
            color: #ff6d37;            
        `

        const Span = styled.span`
            font-size: 20px;
            font-weight: 300;
            color: #000000;            
        `
        const Heading2 = styled.h2`
            transform: translate(0px, -100px);
            transition: 1s;
            margin-top: 180px;
            font-size: 95px;
            line-height: 110px;
            font-family: Teko;
            font-weight: 500;
            color: #000000;
            text-align: center;
            text-transform: uppercase;          
        `
        const ColorV = styled.span`            
            color: #c1eb18;
            font-family: Teko;                        
        `


        const { data } = this.props;
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }

        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)


        return (
            <Section>
                <Container>
                    <Heading2>Planes Hosting <ColorV>CloudLinux</ColorV></Heading2>
                    <ServiceRow>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    Personal
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=2"
                                        onClick={() => {
                                            console.log('Clic en Comprar Host 1, enviando evento');
                                            if (window.gtag) {
                                                window.gtag('event', 'inicio_compra_host1', {
                                                    event_category: 'Compra',
                                                    event_label: 'Hosting 1',
                                                    value: 89997  // Si quieres, puedes agregar el precio
                                                });
                                            }
                                        }}>
                                        Hosting Personal
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    Ideal para emprendedores y Landing Pages
                                </ServiceText>
                                <ServiceText>
                                    <Color>1</Color> Sitio Web
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>1</Color> Gb. SSD de espacio en <Color>RAID 10</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color1><FontAwesomeIcon icon={faTimesCircle} size="1x" /></Color1>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>20</Color> Gb. de transferencia
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Certificado SSL GRATIS
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>5</Color> Correos corporativos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>3</Color> Bases de datos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color1><FontAwesomeIcon icon={faTimesCircle} size="1x" /></Color1>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    SO CloudLinux
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Panel de control <br></br><ColorAdmin>DirectAdmin</ColorAdmin>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de Devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'Hosting Personal').price}<Span>/año</Span>
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=2"
                                    onClick={() => {
                                        console.log('Clic en Comprar Host 1, enviando evento');
                                        if (window.gtag) {
                                            window.gtag('event', 'inicio_compra_host1', {
                                                event_category: 'Compra',
                                                event_label: 'Hosting 1',
                                                value: 89997  // Si quieres, puedes agregar el precio
                                            });
                                        }
                                    }}>
                                    <span>
                                        Contrata Ahora
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    Básico
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=44"
                                        onClick={() => {
                                            console.log('Clic en Comprar Host 2, enviando evento');
                                            if (window.gtag) {
                                                window.gtag('event', 'inicio_compra_host2', {
                                                    event_category: 'Compra',
                                                    event_label: 'Hosting 2',
                                                    value: 109999  // Si quieres, puedes agregar el precio
                                                });
                                            }
                                        }}>
                                        Hosting Básico
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    Ideal para pequeños negocios y sitios personales
                                </ServiceText>
                                <ServiceText>
                                    <Color>1</Color> Sitio Web
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>2</Color> Gb. SSD de espacio en <Color>RAID 10</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color1><FontAwesomeIcon icon={faTimesCircle} size="1x" /></Color1>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>40</Color> Gb. de transferencia
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Certificado SSL GRATIS
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>10</Color> Correos corporativos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>10</Color> Bases de datos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color1><FontAwesomeIcon icon={faTimesCircle} size="1x" /></Color1>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    SO CloudLinux
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Panel de control <br></br><ColorAdmin>DirectAdmin</ColorAdmin>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de Devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'Hosting Básico').price}<Span>/año</Span>
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=44"
                                    onClick={() => {
                                        console.log('Clic en Comprar Host 2, enviando evento');
                                        if (window.gtag) {
                                            window.gtag('event', 'inicio_compra_host2', {
                                                event_category: 'Compra',
                                                event_label: 'Hosting 2',
                                                value: 109999  // Si quieres, puedes agregar el precio
                                            });
                                        }
                                    }}>
                                    <span>
                                        Contrata Ahora
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    Corporativo
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=4"
                                        onClick={() => {
                                            console.log('Clic en Comprar Host 3, enviando evento');
                                            if (window.gtag) {
                                                window.gtag('event', 'inicio_compra_host3', {
                                                    event_category: 'Compra',
                                                    event_label: 'Hosting 3',
                                                    value: 129999  // Si quieres, puedes agregar el precio
                                                });
                                            }
                                        }}>
                                        Hosting Corporativo
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    Ideal para empresas y tiendas virtuales
                                </ServiceText>
                                <ServiceText>
                                    <Color>1</Color> Sitio Web
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>5</Color> Gb. SSD de espacio en <Color>RAID 10</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>Dominio GRATIS 1 año </Color> <Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>100</Color> Gb. de transferencia
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Certificado SSL GRATIS
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>15</Color> Correos corporativos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>15</Color> Bases de datos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Dominio estacionado <Color>1</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    SO CloudLinux
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Panel de control<br></br> <ColorCpanel>cPanel</ColorCpanel>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de Devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'Hosting Corporativo').price}<Span>/año</Span>
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=4"
                                    onClick={() => {
                                        console.log('Clic en Comprar Host 3, enviando evento');
                                        if (window.gtag) {
                                            window.gtag('event', 'inicio_compra_host3', {
                                                event_category: 'Compra',
                                                event_label: 'Hosting 3',
                                                value: 129999  // Si quieres, puedes agregar el precio
                                            });
                                        }
                                    }}>
                                    <span>
                                        Contrata Ahora
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceNumber>
                                    Empresarial
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=89"
                                        onClick={() => {
                                            console.log('Clic en Comprar Host 4, enviando evento');
                                            if (window.gtag) {
                                                window.gtag('event', 'inicio_compra_host4', {
                                                    event_category: 'Compra',
                                                    event_label: 'Hosting 4',
                                                    value: 189997  // Si quieres, puedes agregar el precio
                                                });
                                            }
                                        }}>
                                        Hosting Empresarial
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    Ideal para sitios con altos volúmenes de usuarios
                                </ServiceText>
                                <ServiceText>
                                    <Color>1</Color> Sitio Web
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>10</Color> Gb. SSD de espacio en <Color>RAID 10</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>Dominio GRATIS 1 año </Color> <Color2><FontAwesomeIcon icon={faCheck} size="1x" /></Color2>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>200</Color> Gb. de transferencia
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Certificado SSL GRATIS
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>20</Color> Correos corporativos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>20</Color> Bases de datos
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Dominio estacionado <Color>1</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    SO CloudLinux
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Panel de control<br></br> <ColorCpanel>cPanel</ColorCpanel>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de Devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'Hosting Empresarial').price}<Span>/año</Span>
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=89"
                                    onClick={() => {
                                        console.log('Clic en Comprar Host 4, enviando evento');
                                        if (window.gtag) {
                                            window.gtag('event', 'inicio_compra_host4', {
                                                event_category: 'Compra',
                                                event_label: 'Hosting 4',
                                                value: 189997  // Si quieres, puedes agregar el precio
                                            });
                                        }
                                    }}>
                                    <span>
                                        Contrata Ahora
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }

}

export const query = graphql`
  query {
    allPricesJson(filter: { page: { eq: "hosting-colombia" }, section: { eq: "planes" } }) {
      nodes {
        items {
          name
          price
        }
      }
    }
  }
`

const HostingPage = (props) => (
    <StaticQuery
        query={query}
        render={(data) => (
            <Hosting
                data={data}
            />
        )}
    />
)
export default HostingPage;